<template>
  <div class="custom-center">
    <slot></slot>
  </div>
</template>

<script>
export default {
    name: "Center"
}
</script>
<style lang="scss">
.custom-center {
//   background: red;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column nowrap;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/kitchen/center.vue